import React from 'react'
import { AdjustIcon } from '../../../../../../components/Uploader/Styles'
import EyeIco from '../../../../../../components/icons/EyeIco'
import FileIcon from '../../../../../../components/icons/FileIcon'
import {
  FileContainer,
  FileDisplaySection,
  FileNameText,
  FileSizeText,
  IconContainer,
} from '../../style'
import { getFileSize } from '../EligibiltyCriteria/CommonFunctions'

export default function DocumentDisplay({
  showEyeIco,
  spacing,
  file,
  handleClick,
}) {
  return (
    <FileDisplaySection spacing={spacing}>
      <FileContainer>
        <AdjustIcon alignContent>
          <FileIcon />
        </AdjustIcon>
        <FileNameText>{file[0]?.name}</FileNameText>
        <FileSizeText>{getFileSize(file[0]?.size)}</FileSizeText>
      </FileContainer>
      {showEyeIco && (
        <IconContainer onClick={handleClick}>
          <EyeIco />
        </IconContainer>
      )}
    </FileDisplaySection>
  )
}
